import React, { useState } from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import { useTranslation } from "react-i18next";
import { ADDHEADING, ADDSUBHEADING, ADDBODY } from "../../Uitls/ComponentType";
const TextWindow = (props) => {
  const { getLayerDetails } = props;
  const { t } = useTranslation();

  return (
    <>
      <div className="textWindow">
        <div className="addTextscroll">
          <div
            id="addHeading"
            className="addHeading mb-3 mr-3"
            draggable={true}
            onDragStart={(e) => {
              getLayerDetails(e.target.id, ADDHEADING);
            }}
            onDragEnd={() => {
              getLayerDetails("", "");
            }}
          >
            <span>{t("Heading")}</span>
          </div>
          <div
            id="addSubHeading"
            className="addSubHeading  mb-3 mr-3"
            draggable={true}
            onDragStart={(e) => {
              getLayerDetails(e.target.id, ADDSUBHEADING);
            }}
            onDragEnd={() => {
              getLayerDetails("", "");
            }}
          >
            <span>{t("Sub Heading")}</span>
          </div>
          <div
            id="addBody"
            className="addBody  mb-3 mr-3"
            draggable={true}
            onDragStart={(e) => getLayerDetails(e.target.id, ADDBODY)}
            onDragEnd={() => {
              getLayerDetails("", "");
            }}
          >
            <span>{t("Body")} </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default TextWindow;
